<template>
  <div>
    <BookingDetailsPanel ref="BookingDetails" printTitle="Appointment Confirmation">
    </BookingDetailsPanel>
    <div class="text-center btn-container pt-5">
      <v-layout row wrap>
        <v-flex sm4 class="pa-1">
          <v-btn class="ma-2" color="primary" @click="print()"
            ><v-icon>mdi-printer</v-icon>
            PRINT
          </v-btn>
        </v-flex>
        <v-flex sm4 class="pa-1">
          <v-btn id="adtc-btn" class="ma-2" color="primary">
            <v-icon>mdi-calendar-plus</v-icon>
            Add to Calendar
          </v-btn>
        </v-flex>
        <v-flex sm4 class="pa-1">
          <v-btn class="ma-2" color="primary" @click="exitClick()"
            ><v-icon>mdi-exit-run</v-icon>EXIT
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import BookingDetailsPanel from '@/components/BookingDetailsPanel.vue';
// eslint-disable-next-line camelcase
import { atcb_action } from 'add-to-calendar-button';
import { mapGetters, mapActions } from 'vuex';
import SessionState from '../models/SessionState';

export default {
  components: {
    BookingDetailsPanel,
  },
  data() {
    return {
      appointmentDetails: {},
    };
  },
  computed: {
    ...mapGetters('bookingDetails', [
      'siteName',
      'siteAddress',
      'confirmationNumber',
      'formattedCheckinDateTime',
      'bookingDateTime',
      'bookingDuration',
    ]),
    ...mapGetters('userInfo', ['firstName', 'lastName', 'testTypeText', 'phone', 'email']),
  },
  mounted() {
    this.appointmentDetails = {
      name: `SC DMV Appointment - ${this.testTypeText}`,
      description: 'Please arrive no more than 30 minutes early.',
      startDate: this.bookingDateTime,
      endDate: this.bookingDateTime,
      location: this.siteName,
      options: [
        'Apple',
        'Google',
        'iCal',
        'Microsoft365',
        'MicrosoftTeams',
        'Outlook.com',
        'Yahoo',
      ],
      timeZone: 'currentBrowser',
      trigger: 'click',
      iCalFileName: 'Reminder-Event',
    };
    this.$nextTick(() => {
      const button = document.querySelector('#adtc-btn');
      button.addEventListener('click', () => atcb_action(this.appointmentDetails, button));
    });
  },
  methods: {
    ...mapActions({ isLogInAction: 'isLogIn' }),
    nextPage(page) {
      this.$emit('navigateTo', page);
    },
    addToCalendar() {
      atcb_action();
    },
    print() {
      console.log('Inside print of ConfirmationPage');
      this.$refs.BookingDetails.Printer();
    },
    exitClick() {
      this.isLogInAction({ value: false });
      SessionState.ClearSession();
      this.$emit('navigateTo', 'LoginPage');
    },
  },
};
</script>

<style>
@import 'add-to-calendar-button/assets/css/atcb.css';
</style>
